import ilComponent from './SourceDisplay'

export default Vue => {
    Vue.component(ilComponent.name, ilComponent);
}
